import React from 'react';
import PropTypes from 'prop-types';
import popOverTypes from './popOverTypes';

const propTypes = {};
const defaultProps = {};

const PopOverPopupContainer = React.forwardRef((props, ref) => {
	let Tag = {
		[popOverTypes.MENU]: 'ul',
		[popOverTypes.DIALOG]: 'div',
		[popOverTypes.LISTBOX]: 'div',
		[popOverTypes.GRID]: 'table',
		[popOverTypes.TREE]: 'div',
	}[props.role];

	const {
		containerTag,
		...restOfProps
	} = props;

	Tag = containerTag || Tag;
	
	return (
		<Tag {...restOfProps} ref={ref} >
			{props.children}
		</Tag>
	);
});

PopOverPopupContainer.propTypes = propTypes;
PopOverPopupContainer.defaultProps = defaultProps;

export default PopOverPopupContainer;